module.exports = __webpack_public_path__ + "img/loginSchoolIcon.8467de21.png";